export type ShellPopupPhase =
	| "closed"
	| "waiting_provider"
	| "waiting_fresh_boot"
	| "opening"
	| "open"
	| "closing";

export function isPopupVisiblePhase(phase: ShellPopupPhase): boolean {
	return phase === "opening" || phase === "open";
}

export function resolvePopupCloseTargetPhase(granted: boolean): ShellPopupPhase {
	return granted ? "closing" : "closed";
}